<div class="task-panel" [class.collapsed]="collapsed">

  <div class="task-panel-header">

    <div class="title">

      <!-- <span class="icon">
        <i class="far fa-download"></i>
      </span> -->

      <span>
        {{'My Exports' | translate}}
      </span>

    </div>

    <div class="actions">
      <ng-container *ngIf="tasks$ | async as tasks">
        <div class="icon-btn" *ngIf="apiLoader && tasks.Downloads.length > 0">
          <p-progressSpinner [style]="{ width: '22px', height: '22px' }" strokeWidth="6" animationDuration=".5s"></p-progressSpinner>
        </div>
      </ng-container>

      <button
        class="icon-btn"
        (click)="reload()">
            <i class="far fa-refresh"></i>
      </button>

      <button      
        class="icon-btn"
        (click)="routeToDownloadManager()">
            <i class="fal fa-long-arrow-right"></i>
      </button>

      <button
        class="icon-btn"
        (click)="clearCompleted()">
            <i class="far fa-times"></i>
      </button>
    </div>

  </div>
  <div class="task-panel-body">
      <div *ngIf="taskService?.tempTask" class="export-container">
        <div class="icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="export-icon">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
          </svg>
        </div>

        <h3 class="export-title">{{'Export File' | translate}}</h3>
        <p class="export-description">
          {{'Please enter a name for your file before exporting. Do not include file extensions (e.g., .csv, .pdf).' | translate}}
        </p>

        <div class="export-form">
          <div class="input-group">
            <input 
              type="text" 
              required
              [(ngModel)]="taskService.tempTask.FileName"
              placeholder="my-awesome-report" 
              class="filename-input"
            />
          </div>

          <div class="button-group">
            <button 
              type="button" 
              (click)="cancelNewTask()"
              class="btn btn-secondary">
              {{'Cancel' | translate}}
            </button>
            <button 
              type="submit" 
              (click)="starkNewTask()"
              [disabled]="taskService.tempTask?.FileName?.length < 4"
              class="btn btn-primary">
              {{'Export' | translate}}
            </button>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!taskService?.tempTask">
        <ng-container *ngIf="tasks$ | async as tasks">
          <div
            *ngIf="!tasks.Downloads.length && !apiLoader"
            class="empty">
  
            {{'No background jobs running' | translate}}
          </div>
  
          <div
              *ngIf="apiLoader && !tasks.Downloads?.length"
              class="empty">
                <p-progressSpinner [style]="{ width: '22px', height: '22px' }" strokeWidth="9" animationDuration=".5s"></p-progressSpinner>
          </div>
  
  
          <div
            *ngFor="let task of tasks.Downloads; trackBy: trackById"
            class="task-card">
  
            <div class="task-header">
  
              <div class="task-title">
                <span
                  class="description">
                  <i [style.color]="FileConfig[task?.FileType || 'default']?.color" [class]="FileConfig[task?.FileType || 'default']?.icon"></i>
                </span>
  
                <span>{{ task.Title | translate}}</span>
              </div>
  
              <div class="card-actions">
                <button
                  *ngIf="task?.Status === 'Completed'"
                  class="icon-btn"
                  (click)="taskService.downloadAsync(task)">
                      <i class="fal fa-download"></i>
                </button>
      
                <button
                  class="close-btn"
                  *ngIf="task?.Status === 'Failed'"
                  (click)="retry(task)">
                    <i class="fal fa-repeat"></i>
                </button>

                <button
                  class="close-btn"
                  (click)="remove(task)">
                    <i class="fal fa-trash"></i>
                </button>
              </div>
  
            </div>
  
            <div
              *ngIf="task.Description"
              class="description">
  
              {{ task.Description | translate }}
  
            </div>

            <div
              *ngIf="task.CreatedAt"
              class="description">
  
              {{ task.CreatedAt }}
  
            </div>

  
            <div
              *ngIf="task.Status"
              class="description">
              <div
                class="icon-status-bt"
                [style.color]="StatusConfig[task.Status]?.color">
                  <i [class]="StatusConfig[task.Status]?.icon"></i>
                  <span>{{ task.Status | translate}}</span>
              </div>
            </div>

  
            <!-- Processing -->
            <ng-container *ngIf="taskService.downloadProgress[task?.JobId]?.downloading">
              <div class="progress_dm">
                <div
                  class="progress-fill"
                  [style.width.%]="taskService.downloadProgress[task?.JobId]?.progress">
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
  </div>

</div>